/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HistoryExportRequest } from '../../models/history-export-request';

export interface PostApiAgentV1IdHistoryExport$Json$Params {

/**
 * The unique identifier of the agent.
 */
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * The request payload for agent history export.
     */
    body?: HistoryExportRequest
}

export function postApiAgentV1IdHistoryExport$Json(http: HttpClient, rootUrl: string, params: PostApiAgentV1IdHistoryExport$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, postApiAgentV1IdHistoryExport$Json.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

postApiAgentV1IdHistoryExport$Json.PATH = '/private/v1/agents/{id}/history-export';
